import {
  formatNormalNumber,
  createKpiTileItem,
  formatPercentageValue,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { skusToBeDeleted, skusToBeDeletedDelta } = data.getPOReachMetrics;

    return createKpiTileItem(
      "SKU's To Be Deleted",
      formatNormalNumber(skusToBeDeleted),
      skusToBeDeletedDelta !== null && skusToBeDeletedDelta !== undefined
        ? {
            isPositiveValue: skusToBeDeletedDelta >= 0,
            text: formatPercentageValue(Math.abs(skusToBeDeletedDelta)),
            sideLabel: '',
            showArrow: Number(skusToBeDeletedDelta) !== 0,
          }
        : null
    );
  },
};
